import * as React from 'react';

import { cn } from '@/lib/utils';

function GridLayout({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'grid min-w-0 grid-cols-1 gap-4 xs:grid-cols-2 xs:gap-6 lg:grid-cols-3 lg:gap-10 items-stretch',
        className,
      )}
      {...props}
    />
  );
}

export { GridLayout };
